import {useEffect, useState} from 'react';

export const useIsVisible = (elementRef: {
  current?: null | HTMLElement;
}): boolean => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.intersectionRatio > 0) {
          setIsVisible(true);
          observer.disconnect();
        }
      }
    });
    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [elementRef]);

  return isVisible;
};
